module.exports = __webpack_public_path__ + "static/Karen_Thomson_SFR_logo-1c15b072a70e600f551ba85a1d265611.jpeg";